{
  "$schema": "./schema.json",
  "bids": {
    "companyLoanBid": {
      "amount": "Amount",
      "paybackTimeMonths": "Repayment time",
      "amortizationMethod": "Amortisation type",
      "lenderMonthlyInterest": {
        "yearly": "Yearly interest rate (shown in contract)",
        "monthly": "Monthly interest rate (shown in contract)"
      },
      "lenderMonthlyAmount": "Fixed monthly fee shown in contract",
      "averageMonthlyPayment": {
        "title": "Monthly payment",
        "helperTitle": "Average monthly payment"
      },
      "firstMonthPayment": "Payment (first month)",
      "averageMonthlyCost": "Interest payment",
      "firstMonthCost": "Interest payment",
      "averageMonthlyAmortisation": "Principal repayment",
      "firstMonthAmortisation": "Principal repayment",
      "comparableMonthlyInterestRate": "Effective monthly interest",
      "comparableYearlyInterestRate": "Effective yearly interest",
      "firstMonthInterestRate": "Interest rate (first month)",

      "earlyRepaymentFee": "Cost for early repayment",
      "setupFee": "Setup fee",
      "postalFee": "Postal fee (per month)",
      "directDebitFee": "Direct debit fee (per month)"
    },
    "factoringBid": {
      "purchaseLimit": "Purchase limit",
      "purchasedAmountPercent": "Financing rate (in %)",
      "paymentTermsDays": "days",
      "commissionPercent": "Credit fee",
      "withRegress": "Recourse",
      "withRegressYes": "Yes",
      "withRegressNo": "No",
      "regressNumDaysAfterDueDate": "Regress number of days",
      "limitFeePerYearPercent": "Limit fee (per year)",
      "handlingFeePerInvoice": "Handling fee per invoice",
      "monthlyFee": "Monthly fixed fee",
      "amount": "Amount",
      "averageMonthlyCost": "Monthly cost",
      "firstMonthCost": "Commission (first month)",
      "comparableMonthlyInterestRate": "Effective monthly interest",
      "comparableYearlyInterestRate": "Effective yearly interest",
      "firstMonthInterestRate": "First month interest rate",
      "earlyRepaymentFee": "Cost for early repayment",
      "setupFee": "Setup fee",
      "postalFee": "Postal fee (per month)",
      "directDebitFee": "Direct debit fee (per month)"
    },
    "realEstateBid": {
      "amount": "Amount",
      "paybackTimeMonths": "Loan term",
      "amortizationMethod": "Amortisation type",
      "lenderMonthlyInterest": {
        "yearly": "Yearly interest rate (shown in contract)",
        "monthly": "Monthly interest rate (shown in contract)"
      },
      "lenderMonthlyAmount": "Fixed monthly fee shown in contract",
      "amortizationDuringTerm": "Amortisation during loan term",
      "amortizationInPercent": "Amortisation in percent",
      "averageMonthlyPayment": {
        "title": "Monthly payment",
        "helperTitle": "Average monthly payment"
      },
      "firstMonthPayment": "Payment (first month)",
      "averageMonthlyCost": "Interest payment",
      "firstMonthCost": "Interest payment",
      "averageMonthlyAmortisation": "Principal repayment",
      "firstMonthAmortisation": "Principal repayment",
      "comparableMonthlyInterestRate": "Effective monthly interest",
      "comparableYearlyInterestRate": "Effective yearly interest",
      "firstMonthInterestRate": "Interest rate (first month)",

      "earlyRepaymentFee": "Cost for early repayment",
      "setupFee": "Setup fee",
      "postalFee": "Postal fee (per month)",
      "directDebitFee": "Direct debit fee (per month)"
    },
    "leasingBid": {
      "amount": "Amount",
      "paybackTimeMonths": "Repayment time",
      "downPayment": "Down payment",
      "monthlyPayment": {
        "title": "Monthly payment",
        "helperTitle": "Average monthly payment"
      },
      "firstMonthPayment": "Payment (first month)",
      "terminalValue": {
        "title": "Terminal value",
        "description": "Terminal value only applies for financial leasing contracts (i.e. not for rent). The value represents the estimated value of the object at the end of the leasing period. Once the contract expires you will be able to purchase the leasing object from the leasing company by paying the terminal value."
      },
      "contractType": {
        "label": "Contract type",
        "LEASING": {
          "title": "Leasing",
          "description": "Leasing is suitable for businesses that want to invest in new or used tools, machines or equipment without needing to buy or borrow money. In the end of the leasing period, you can either prolong the contract, purchase the object for its terminal value or return the object to the leasing company."
        },
        "RENT": {
          "title": "Rent",
          "description": "Sometimes it might be more suitable to rent rather than to lease an object. Especially if you want to be able to change the equipment during the leasing period. In the end of the leasing period you can either prolong the rental agreement or return the object to the leasing company."
        }
      },
      "insuranceMonthlyCost": "Insurance cost (per month)",
      "averageMonthlyCost": "Interest payment",
      "firstMonthCost": "Interest payment",
      "averageMonthlyAmortisation": "Principal repayment",
      "firstMonthAmortisation": "Principal repayment",
      "comparableMonthlyInterestRate": "Effective monthly interest",
      "comparableYearlyInterestRate": "Effective yearly interest",
      "firstMonthInterestRate": "Interest rate (first month)",
      "earlyRepaymentFee": "Cost for early repayment",
      "setupFee": "Setup fee",
      "postalFee": "Postal fee (not included in monthly payment)",
      "directDebitFee": "Direct debit fee (per month)"
    },
    "revolvingCreditBid": {
      "amount": "Credit limit",
      "lenderMonthlyInterest": {
        "yearly": "Interest (per year)",
        "monthly": "Interest (per month)"
      },
      "monthlyAmortisation": "Amortisation (per month)",
      "withdrawalFee": {
        "title": "Withdrawal fee",
        "description": "The withdrawal fee is charged each time you borrow additional funds within your approved credit limit"
      },
      "limitFeePerYear": "Limit fee (per year)",
      "averageMonthlyPayment": "Payment (at 50% utilization rate)",
      "firstMonthPayment": "Payment (at 100% utilization rate)",
      "averageMonthlyCost": "Interest payment",
      "firstMonthCost": "Interest payment",
      "averageMonthlyAmortisation": "Principal repayment",
      "firstMonthAmortisation": "Principal repayment",
      "comparableMonthlyInterestRate": "Effective monthly interest",
      "comparableYearlyInterestRate": "Effective yearly interest",
      "firstMonthInterestRate": "Interest rate (first month)",
      "earlyRepaymentFee": "Cost for early repayment",
      "setupFee": "Setup fee",
      "postalFee": "Postal fee (per month)",
      "directDebitFee": "Direct debit fee (per month)"
    },
    "purchaseFinancingBid": {
      "amount": "Credit limit",
      "lenderMonthlyInterest": {
        "title": "Interest per month",
        "helperTitle": "Interest is calculated monthly and paid in full on the due date.",
        "summaryTitle": "Monthly interest rate",
        "summaryYearly": "Yearly interest rate",
        "summaryTooltip": "Shown in contract"
      },
      "limitFeePerYear": "Limit fee (per year)",
      "paybackTimeDays": "Repayment time (days)",
      "averageMonthlyPayment": {
        "title": "Monthly payment",
        "helperTitle": "Average monthly payment"
      },
      "firstMonthPayment": "Payment (first month)",
      "averageMonthlyCost": "Interest payment",
      "firstMonthCost": "Interest payment",
      "averageMonthlyAmortisation": "Principal repayment",
      "firstMonthAmortisation": "Principal repayment",
      "comparableMonthlyInterestRate": "Effective monthly interest",
      "comparableYearlyInterestRate": "Effective yearly interest",
      "firstMonthInterestRate": "Interest rate (first month)",
      "setupFee": "Setup fee",
      "postalFee": "Postal fee (per month)",
      "directDebitFee": "Direct debit fee (per month)"
    },
    "calculations": {
      "title": "Key calculations for your offer",
      "monthly": "Monthly",
      "firstMonth": "First month",
      "yearly": "Yearly"
    },
    "common": {
      "repayableWithoutFee": "Free",
      "months": "months",
      "month": "month",
      "days": "days",
      "lender": "Lender"
    }
  }
}
